const DEBUG_LOG_STORAGE_KEY = 'anna_debug_logs'

let cachedDebugLogEnabled: boolean | null = null

const resolveDebugLogEnabled = (): boolean => {
  if (!import.meta.env.DEV) return false

  try {
    if (typeof window !== 'undefined') {
      return window.localStorage.getItem(DEBUG_LOG_STORAGE_KEY) === '1'
    }
  } catch {
    // localStorage may be unavailable in some runtime contexts
  }

  return false
}

export const isDebugLogEnabled = (): boolean => {
  if (cachedDebugLogEnabled === null) {
    cachedDebugLogEnabled = resolveDebugLogEnabled()
  }
  return cachedDebugLogEnabled
}

export const resetDebugLogCache = () => {
  cachedDebugLogEnabled = null
}

export const debugLog = (...args: unknown[]) => {
  if (isDebugLogEnabled()) {
    console.log(...args)
  }
}

